enum VendorListType {
  Public = 'Public',
  Private = 'Private',
  Shared = 'Shared',
}
export default VendorListType;
